import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["item", "intersect", "slider", "rank"];
import { FavoriteButton } from "@/components/Buttons";
import CardArtwork from "@/components/Card/CardArtwork";
import { CardContext } from "@/components/Card/CardContext";
import VersatileLink from "@/components/VersatileLink";
import { useSliderPosition } from "@/hooks";
import isShowValuePlanLabel from "@/lib/isShowValuePlanLabel";
import { deliveryDate, deliveryLabel, price } from "@/lib/metaUtil";
import routes from "@/lib/routes";
import styles from "@/styles/Card.module.scss";
import classnames from "classnames";
import { useCallback, useContext, useRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function EpisodeCard(props) {
  var _item$channel;
  const {
      item,
      intersect,
      slider,
      rank
    } = props,
    props_ = _objectWithoutProperties(props, _excluded);
  const cardRef = useRef();
  const {
    classNames,
    active
  } = useSliderPosition(props_, cardRef);
  const context = useContext(CardContext);
  const channelId = Number(item === null || item === void 0 || (_item$channel = item.channel) === null || _item$channel === void 0 ? void 0 : _item$channel.id);
  const showValuePlanLabel = isShowValuePlanLabel({
    channelId
  });
  const handleClick = useCallback(e => {
    if (!item.isAllowedRating) {
      e.preventDefault();
    }
  }, [item]);
  return /*#__PURE__*/_jsx("div", {
    ref: cardRef,
    className: classnames(classNames, {
      [styles.notAllowed]: !item.isAllowedRating,
      [styles.rankingCard]: !!rank
    }),
    children: /*#__PURE__*/_jsx(VersatileLink, {
      href: routes.watchWithRtsid(item),
      children: /*#__PURE__*/_jsx("a", {
        onClick: handleClick,
        children: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(CardArtwork, {
            active: active,
            index: props_.index,
            focusIndex: props_.focusIndex,
            rank: rank,
            item: item,
            intersect: intersect,
            showValuePlanLabel: showValuePlanLabel
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.infoContainer,
            children: [/*#__PURE__*/_jsxs("div", {
              className: styles.info,
              children: [/*#__PURE__*/_jsx("div", {
                className: styles.title,
                children: /*#__PURE__*/_jsx("p", {
                  children: item.name
                })
              }), /*#__PURE__*/_jsx("div", {
                className: styles.delivery,
                children: /*#__PURE__*/_jsx("span", {
                  children: deliveryLabel(item)
                })
              })]
            }), /*#__PURE__*/_jsx("div", {
              className: `${styles.feature}`,
              children: props_.focusIndex != null && /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.title,
                  children: /*#__PURE__*/_jsx("p", {
                    children: item.name
                  })
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.genre,
                  children: item.genres.map(genre => genre.name).join("/")
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.description,
                  children: /*#__PURE__*/_jsx("p", {
                    children: item.description
                  })
                }), /*#__PURE__*/_jsxs("div", {
                  className: styles.delivery,
                  children: [/*#__PURE__*/_jsx("span", {
                    children: deliveryLabel(item)
                  }), " ", /*#__PURE__*/_jsx("span", {
                    children: deliveryDate(item)
                  })]
                }), /*#__PURE__*/_jsxs("div", {
                  className: styles.other,
                  children: [!context.hiddenPrice && item.rights && item.rights.length != 0 && price(item), context.hiddenPrice && /*#__PURE__*/_jsx("span", {}), /*#__PURE__*/_jsx(FavoriteButton, {
                    metaId: item.id,
                    className: styles.favorite,
                    fillGray: true,
                    scale: true,
                    text: "\u304A\u6C17\u306B\u5165\u308A"
                  })]
                })]
              })
            })]
          })]
        })
      })
    })
  });
}